import React, { useEffect } from "react"
import { Alert, Grid } from "@mui/material"

import { useAcrissGroups } from "Pages/OneWay/AcrissGroups/@hooks"
import { acrissGroupData, clearAcrissGroupSignals, isLoadingAcrissGroupData } from "Pages/OneWay/AcrissGroups/@signals"
import AcrissGroupsButton from "./Button"
import AcrissGroupDrawer from "./Drawer"
import AcrissGroupsTable from "./Table"


export default function AcrissGroupsContent() {
	const { getAcrissGroupData } = useAcrissGroups()

	useEffect(() => {
		getAcrissGroupData()

		return clearAcrissGroupSignals
	}, [])

	const isEmpty = !isLoadingAcrissGroupData.value && !acrissGroupData.value?.length

	return <Grid container spacing={1}>
		<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
			<AcrissGroupsButton />
		</Grid>

		{isEmpty && <Grid item xs={12}>
			<Alert severity="info">
				No acriss groups yet. A group joins several acriss codes under one name (for example
				"Compacto" with CCAR and CDAR) so the One Way analyzer can show one column per group
				instead of one per code.
			</Alert>
		</Grid>}

		<AcrissGroupsTable />

		<AcrissGroupDrawer />
	</Grid>
}
